var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","title":"Dupliquer ce point"},on:{"click":function($event){return _vm.duplicateItem()}}},[_c('i',{staticClass:"far fa-fw fa-clone text-secondary"})])
}
var staticRenderFns = []

export { render, staticRenderFns }